export function DeleteConfirmDialog({ confirmDelete, setConfirmDelete, executeDelete }) {
  if (!confirmDelete) return null;
  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/50 modal-overlay" onClick={() => setConfirmDelete(null)}>
      <div className="bg-popover border border-border rounded-lg shadow-xl w-full max-w-sm mx-4 p-5 modal-content" onClick={(e) => e.stopPropagation()}>
        <h3 className="text-sm font-semibold mb-2">Eintrag löschen</h3>
        <p className="text-xs text-muted-foreground mb-4">
          Möchten Sie <strong>"{confirmDelete.name}"</strong> wirklich löschen?
        </p>
        <div className="flex justify-end gap-2">
          <button data-testid="confirm-delete-cancel" onClick={() => setConfirmDelete(null)} className="px-3 py-1.5 text-xs rounded bg-secondary text-foreground hover:bg-secondary/80 transition-colors">
            Abbrechen
          </button>
          <button data-testid="confirm-delete-ok" onClick={executeDelete} className="px-3 py-1.5 text-xs rounded bg-destructive text-destructive-foreground hover:bg-destructive/90 transition-colors">
            Löschen
          </button>
        </div>
      </div>
    </div>
  );
}

export function GlobalOverlay({ visible }) {
  if (!visible) return null;
  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/40 modal-overlay">
      <div className="flex items-center gap-3 bg-popover border border-border rounded-lg shadow-xl px-6 py-4 modal-content">
        <div className="animate-spin h-5 w-5 border-2 border-primary border-t-transparent rounded-full" />
        <span className="text-sm font-medium text-foreground">Bitte warten ...</span>
      </div>
    </div>
  );
}
